//src/firebase/ firebase.js
import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage'; 
import { sendPasswordResetEmail } from 'firebase/auth';

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyB4VBts0-yRBgGljR1ij9-p9lq5u9LoV6U",
  authDomain: "iyantrix.in",
  projectId: "asset-management-db907",
  storageBucket: "asset-management-db907.appspot.com",
  messagingSenderId: "710028535059",
  appId: "1:710028535059:web:97e92ccdf472c34a9d26e6",
  measurementId: "G-DT7FFPBNB3"
};

// Prevent re-initializing in development
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // ✅ Initialize storage

export { auth, db, storage, firebaseConfig, app }; // ✅ Export storage
